/**
 * Window property names exposed by the app in test mode.
 * Keep in sync with packages/helix/tests/src/e2e/boot-test-globals.ts.
 */
export const BOOT_TEST_GLOBALS = {
  MODULE_ROUTES_READY: '__moduleRoutesReady',
  APP_BOOT_READY: '__appBootReady',
  HELIX_ROUTER: '__helixRouter',
  HELIX_LAYOUTS: '__helixLayouts',
  HELIX_LOCALE: '__helixLocale',
  HELIX_VUETIFY_LOCALE: '__helixVuetifyLocale',
  HELIX_TRANSLATE: '__helixTranslate',
  HELIX_TRANSLATIONS: '__helixTranslations',
  HELIX_TEST_SETTINGS: '__helixTestSettings',
} as const;
